import React, { useState } from 'react';
import $ from 'jquery';
import RTL from './components/Rtl';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Loader from './components/Loader';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getOne } from './utils/dataProvider';
import { Actions } from './redux/DictionaryRedux';


const AdminLayout = React.lazy(() => import('./components/AdminLayout'));
const Layout = React.lazy(() => import('./components/Layout'));
const Error404 = React.lazy(() => import('./views/error/Error404'));
function App() {
  const [loadDic, setLoadDic] = useState(true);
  const dispatch = useDispatch();
  const changeTheme = () => {
    var darkTheme = localStorage.getItem('darkTheme');
    if (darkTheme) {
      $('html').addClass('dark');
      $('#changeThemeText').text('حالت روشن');
      $('#changeThemeSwitch').prop('checked',true); 
    }
    else {
      $('html').removeClass('dark');
      $('#changeThemeText').text('حالت تیره');
      $('#changeThemeSwitch').prop('checked',false);
    }

  }
  const loadDictionary = () => {
    let lan = localStorage.getItem('current_lan');
    if (!lan) {
      lan = 'fa';
      localStorage.setItem('current_lan', lan);
    }
    getOne<any>('v1/translations/' + lan, {})
      .then(result => {
        if (result.success ) {
          var data = result.entity;
          dispatch(Actions.SetDictionary( data.translations));
          setLoadDic(false);
        }
      });
  }
  useEffect(() => {
    loadDictionary();
    $('#changeThemeSwitch').change(function () {
      if ($(this).is(":checked")) {
        localStorage.setItem('darkTheme', "true");
      }
      else
        localStorage.removeItem('darkTheme');
      changeTheme();
    });
    changeTheme();
    //document.getElementsByName('html')[0].className = darkTheme ? "dark" : "";
  }, [])

  return (loadDic ? (<Loader />) :

    <RTL>
      <React.Suspense fallback={<Loader />} >
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/app/dashboard" />} />
          <Route
            exact
            path="/app"
            render={() => <Redirect to="/app/dashboard" />}
          />
          <Route path="/app" component={AdminLayout} />
          <Route path="/*" component={Layout} />
          <Route component={Error404} />
        </Switch>
      </React.Suspense>
      <ToastContainer />

    </RTL>

  );
}

export default App;
